import axios from 'axios';
import { apiInstancesSurveysResponsesUrl } from '../config';

/**
 * POST Post Put Survey Responses No Cache.
 *
 * @author Yves Matta <yves.matta@qochealth.com>
 * @param {{}} props
 * @param {{}} [props.requestConfig] - additional config for request
 * @param {{}} [props.method=post] - post | put
 * @param {SurveyResponse} [props.surveyResponse] - SurveyResponse object or array of SurveyResponse objects
 * @param {SurveyResponse[]} [props.surveyResponses] - array of SurveyResponse objects
 * @param {{}} [props.type=post] - post | put
 * @returns {Promise}
 */
const postPutSurveyResponsesNoCache = props => {
  const {
    method = 'post',
    requestConfig,
    surveyResponse,
    surveyResponses,
    type = 'post'
  } = props;

  const url = apiInstancesSurveysResponsesUrl;
  const data = surveyResponses || [surveyResponse];

  return axios({
    data,
    method: method || type,
    url,
    ...requestConfig
  });
};

export default postPutSurveyResponsesNoCache;



// WEBPACK FOOTER //
// ./src/qoc-sdk/library/postPutSurveyResponsesNoCache.js